import { Injectable, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { map } from 'rxjs';
import { createFetchState } from '@at/shared';
import { getTripId } from '@at/trip';
import { DatesApi } from '../api';
import { CURRENT_TRIP_MEMBERS } from '@at/trip/people';

@Injectable()
export class DatesService {
  #datesApi = inject(DatesApi);
  #router = inject(Router);
  #tripMembers = inject(CURRENT_TRIP_MEMBERS);
  #tripId = getTripId();

  public datesSummary = toSignal(
    createFetchState({
      fetchCall: () => this.#datesApi.getSummary().pipe(map((r) => r.dateSummary)),
    }),
  );

  public updateDatesSummary(navigateToRoot = false): void {
    const state = this.datesSummary();
    if (state) state.update();

    if (navigateToRoot) {
      this.navigateToModuleRoot();
    }
  }

  public navigateToModuleRoot() {
    this.#router.navigate(this.getModuleRootPath());
  }

  public getModuleRootPath(): string[] {
    return [`/trip/${this.#tripId}/dates`];
  }
}
